<template>
  <v-dialog
    content-class="yes-no-popup"
    :value="visiblePopup"
    @keydown.esc="onNoClickButton"
    @click:outside='onNoClickButton'
    :max-width="width"
  >
    <v-card class="popup-wrapper" :style='{"max-width": width}'>
      <div class='close-action'>
        <span class='close_btn' @click='onNoClickButton'>
          <span class="material-icons-outlined">
            close
          </span>
        </span>
      </div>
      <div class="title">{{$t(title)}}</div>
      <div class="message">{{$t(message)}}</div>
      <div class="buttons">
        <v-btn v-if='showNoButton' small depressed :class="['no-button', showYesButton ? 'btn-secondary' : 'btn-primary']" @click="onNoClickButton()">
          {{$t(noCaption)}}
        </v-btn>
        <v-btn v-if='showYesButton' small depressed class="yes-button btn-primary" @click="onYesClickButton()" :loading='loading'>
          {{$t(yesCaption)}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>

import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'YesNoPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    title: String,
    message: String,
    yesCaption: String,
    noCaption: String,
    loading: {
      required: false,
      type: Boolean,
      default: false,
    },
    showNoButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    showYesButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    visiblePopup: {
      type: Boolean,
      required: true,
    },
    width: {
      type: String,
      default: '380px',
      required: false,
    },
  },
  methods: {
    onYesClickButton() {
      this.$emit('clicked', true);
    },
    onNoClickButton() {
      this.$emit('clicked', false);
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/styles/design-system';

.yes-no-popup {
  .popup-wrapper {
    max-width: rem(380);
    padding: $space-8 $space-10;

    .close-action {
      float: right;

      .close_btn {
        float: right;
        margin-top: rem(-15);
        margin-right: rem(-15);

        &:hover {
          cursor: pointer;
          color: var(--brand-primary);
        }
      }
    }

    .title {
      color: var(--text-primary);
      font-size: $font-size-base !important;
      font-weight: 600;
      letter-spacing: 1.12px;
      line-height: $line-height-snug !important;
      text-transform: uppercase;
      padding-bottom: $space-6;
      padding-right: $space-6;
    }

    .message {
      font-weight: normal;
      color: var(--text-primary);
      font-size: $font-size-base;
      letter-spacing: 0;
      line-height: $space-4;
      white-space: pre-line;
    }

    .buttons {
      text-align: right;
      padding-top: $space-7;

      .no-button {
        height: $btn-height-md;
        border-radius: $radius-sm;
      }

      .yes-button {
        height: $btn-height-md;
        width: fit-content;
        border-radius: $radius-sm;
        margin-left: $space-2;

        .v-btn__loader .v-progress-circular {
          color: #ffffff !important;
        }
      }
    }
  }
}
</style>
